<template>
  <Teleport to="body">
    <van-overlay :show="visible" class="dialog-overlay rererer" :z-index="1000">
      <div v-if="isNanTong" class="dialog nantong bbbbaaaacccc">
        <div class="register-succsss-info accountBg">
          <!-- getImageUrlFn -->
          <div class="form-content" :style="`background-image:url('${'/images/light/fasterRg.png'}')`">
          </div>
          <div class="px-[22px] account">
            <div class="flex items-center h-[44px] w-full">
              <SvgIcon name="frame" class="w-[24px] shrink-0 mr-[20px] h-[24px]" />
              <div class="w-full line-clamp-1">{{ username }}</div>
              <SvgIcon name="copy" class="w-[20px] shrink-0 ml-[20px] h-[20px]" @click="copyText(username)" />
            </div>
            <div class="flex items-center h-[44px]">
              <SvgIcon name="lock" class="w-[24px] shrink-0 mr-[20px] h-[24px]" />
              <div class="w-full line-clamp-1">{{ password }}</div>
              <SvgIcon name="copy" class="w-[20px] ml-[20px] shrink-0 h-[20px]" @click="copyText(password)" />
            </div>
          </div>
          <div class="form-footer">为避免遗忘，请务必截屏保存！！！</div>
        </div>
        <SvgIcon name="closeX" @click="close" class="w-[24px] close h-[24px]" />
      </div>
      <div v-if="!isNanTong" class="dialog">
        <div class="register-succsss-info">
          <div class="form-content">
            <h1 class="title">hi，你的帐密已生成</h1>
            <div class="account-info">
              <span class="left-name">账号</span>
              <div class="generator-box">
                <p>{{ username }}</p>
                <span class="copy-icon" @click="copyText(username)">
                </span>
              </div>
            </div>
            <div class="account-info">
              <span class="left-name">密码</span>
              <div class="generator-box">
                <p>{{ password }}</p>
                <span class="copy-icon" @click="copyText(password)"></span>
              </div>
            </div>
          </div>
          <div class="form-footer">为避免遗忘，请务必截屏保存！！！</div>
        </div>
        <van-icon @click="close" class="close" name="close" size="32" />
      </div>
    </van-overlay>
  </Teleport>
</template>

<script setup>
import { watch } from 'vue'
const visible = ref(false)
const username = ref('')
const password = ref('')
const globalStor = useGlobalStore()
const { appConfig, isNanTong } = storeToRefs(globalStor)
const emit = defineEmits(['update:visible']);
const copyText = (text) => {
  copyToClipboard(text)
  showToast('复制成功')
}
const close = () => {
  visible.value = false
};

watch(visible, (newVal) => {
  console.log('bbb changed:', newVal);
});

defineExpose({
  username,
  password,
  visible
});

</script>

<style lang="scss" scoped>
.register-succsss-info {
  width: 320px;
  overflow: hidden;
  border-radius: 15px;

  .form-content {
    height: 300px;
    padding: 63px 32px;
  }

  h1 {
    font-size: 24px;
    margin-bottom: 42px;
  }
}

.account-info {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 24px;

  .left-name {
    color: #ffcb58;
    font-size: 16px;
  }

  p {
    flex: 1;
  }

  .copy-icon {
    width: 18px;
    display: block;
    width: 18px;
    height: 18px;
    background: url('/svg/dark/copy.svg') no-repeat center center;
    background-size: 100% 100%;
  }

  .generator-box {
    width: 213px;
    height: 35px;
    display: flex;
    align-items: center;
    font-size: 16px;
    padding: 0 20px 0 10px;
    background-color: #26262ccc;
  }
}

.form-footer {
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
  color: #202020;
  background-color: #ffcb58;
}

.dialog {
  position: absolute;
  min-height: 130px;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
}

.close {
  position: absolute;
  bottom: -60px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 20;
}

.nantong {
  .register-succsss-info {
    border-radius: 0;
    width: 300px;
    background: linear-gradient(170deg, #FFF 6.3%, #D4D4E8 97.94%);

    .account {

      color: #000;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
    }

    .form-footer {
      color: #8B8B8B;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      height: 32px;
      background-color: unset !important;
    }
  }
}
</style>
